import { useCallback, useMemo } from "react";
import {
  SHCheckbox,
  SHFormControlLabel,
  SHStack,
} from "@components/design-systems";
import { MSTableFilterColumnMenuProps } from "@pages/managed-accounts/model-screener/components/model-screener-table/table/table-head-cell/filter-menu";
import { MSFilterConstants } from "@pages/managed-accounts/model-screener/constant";

type MSTableColumnFilterProps = MSTableFilterColumnMenuProps & {};

export const MSTableColumnFilter = ({ column }: MSTableColumnFilterProps) => {
  const metaData = column.columnDef.meta;
  const isColumnFiltered = column.getIsFiltered();
  const tableColumnFilterValue = column.getFilterValue();

  const originalFilterData = useMemo(() => metaData?.filterData, [metaData]);
  const originalFilterDataValues = useMemo(
    () => originalFilterData?.flatMap((d) => String(d.value)) || [],
    [originalFilterData],
  );

  const columnFilterValue = useMemo(() => {
    if (tableColumnFilterValue) {
      return tableColumnFilterValue as string[];
    }

    return null;
  }, [tableColumnFilterValue]);

  const isAllFilterChecked = useMemo(() => {
    return (
      !isColumnFiltered ||
      columnFilterValue?.length === originalFilterDataValues?.length
    );
  }, [isColumnFiltered, columnFilterValue, originalFilterDataValues]);

  const handleFilterChange = useCallback(
    (value: string, isChecked: boolean) => {
      const currentFilter = columnFilterValue || originalFilterDataValues;
      column.setFilterValue(
        isChecked
          ? currentFilter.filter((item) => item !== value)
          : [...currentFilter, value],
      );
    },
    [column, columnFilterValue, originalFilterDataValues],
  );

  const handleAllFilterChange = useCallback(() => {
    column.setFilterValue(!isAllFilterChecked ? undefined : []);
  }, [column, isAllFilterChecked]);

  return !!originalFilterData ? (
    <SHStack>
      <SHStack>
        <SHFormControlLabel
          size={"small"}
          control={
            <SHCheckbox
              size={"small"}
              checked={isAllFilterChecked}
              onChange={() => handleAllFilterChange()}
              value={MSFilterConstants.MSColumnFilterAll}
            />
          }
          label={MSFilterConstants.MSColumnFilterAll}
        />
      </SHStack>
      {originalFilterData.map((item, index) => {
        const isChecked =
          columnFilterValue?.includes(item.value) || !isColumnFiltered;
        const handleChange = () => handleFilterChange(item.value, isChecked);

        return (
          <SHStack key={index}>
            <SHFormControlLabel
              size={"small"}
              control={
                <SHCheckbox
                  size={"small"}
                  checked={isChecked}
                  onChange={handleChange}
                  value={item.value}
                />
              }
              label={item.label}
            />
          </SHStack>
        );
      })}
    </SHStack>
  ) : null;
};
